import { HttpErrorResponse, HttpResponse } from '@angular/common/http';

import { MappedError } from '../interfaces';

const jsonStringifyErrorReplacer = (_key: string, value: unknown) => {
  if (value instanceof Error) {
    const cache = [];
    return Object.getOwnPropertyNames(value).reduce((acc, propertyKey) => {
      if (cache.indexOf(propertyKey) !== -1) {
        // Circular reference
        return acc;
      }
      cache.push(propertyKey);
      acc[propertyKey] = value[propertyKey];
      return acc;
    }, {});
  }
  return value;
};

/**
 * Use for better monitoring error messages in the extra parameter.
 * @param error
 */
export const mapErrorForMonitoring = (error: unknown): HttpErrorResponse | MappedError => {
  if (error instanceof HttpErrorResponse) {
    return error;
  }
  const parsedError = (error ?? {}) as { errorCode?: string; key?: string; errorMessage?: string; message?: string };
  return {
    json: JSON.stringify(error, jsonStringifyErrorReplacer),
    errorCode: parsedError.errorCode || parsedError.key,
    errorMessage: parsedError.errorMessage || parsedError.message,
  };
};

const errorResponse = (response: unknown) => {
  if (response instanceof HttpResponse) {
    return response.body || {};
  }
  if (response instanceof HttpErrorResponse) {
    return response.error || {};
  }
  return response;
};

const jsonOrString = (o) => {
  if (typeof o === 'string') {
    try {
      return JSON.parse(o);
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (e) {
      return { message: o };
    }
  }
  return o;
};

/**
 * Use for mapping errors in observable catch blocks
 * XHR errors should always respond with Response object and other errors we pass through.
 * @param error
 * @returns {any}
 */
export const mapError = <T>(error: unknown): T => {
  return jsonOrString(errorResponse(error));
};
